export default __webpack_public_path__ + "static/media/re2.a65fb81c.png";